import React from 'react';
import { Grid, makeStyles, Typography, useMediaQuery } from 'housecall-ui';
import theme from 'housecall-ui/dist/Theme';

interface Props {
  title: string;
  subtitle: string;
  summary?: string;
}
const useStyles = makeStyles(() => ({
  element: {
    whiteSpace: 'pre-line',
  },
}));

const ConfirmationElement = ({ title, subtitle, summary }: Props) => {
  const { element } = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Grid item xs={fullScreen ? 12 : 6} className={element}>
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2">{subtitle}</Typography>
      {summary && <Typography variant="subtitle2">{summary}</Typography>}
    </Grid>
  );
};

export default ConfirmationElement;
